import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// import '@style/components/timeRangeSelector.scss';
import '../../styles/components/timeRangeSelector.scss';

function RangeSelector({ type, btns, onClick, selected }) {
  const [current, setCurrent] = useState(selected);
  const handleClick = (btn, index) => {
    setCurrent(index);

    typeof onClick === 'function' && onClick(index, btn);
  };

  useEffect(() => {
    if (current !== selected) {
      setCurrent(selected);
    }
  }, [selected]);
  return (
    <div className="time-selector-wrapper">
      <div
        className={`${type === 'horizontal' && 'horizontal'}
         ${type === 'vertical' && 'vertical'}`}
      >
        {btns.map((btn, index) => (
          <span
            className={`btn ${index === current && 'is-active'}`}
            key={`range-selector-${btn.text || index}`}
            onClick={() => handleClick(btn, index)}
          >
            {btn.text}
          </span>
        ))}
      </div>
    </div>
  );
}

RangeSelector.defaultProps = {
  type: 'horizontal',
  btns: [],
  selected: 0,
  onClick: null,
};

RangeSelector.propTypes = {
  type: PropTypes.string,
  btns: PropTypes.array,
  onClick: PropTypes.func,
  selected: PropTypes.number,
};

export default memo(RangeSelector);
